import React, { Component } from 'react';
import styles from './colorpicker.less.js';
import { Palette } from './palette/palette.js';
import { Hue } from './palette/hue.js';
import { convert } from 'chromatism2';
import { Alpha } from './palette/alpha.js';
import { ColorInput } from './palette/input.js';
import { rgbaToHexA } from '../../utils/color-change.js';

/**
 * @internal
 * @deprecated
 * Workbench 计划不再提供颜色选择面板，可采用自行实现的版本
 */
class CustomSketch extends Component {
    constructor(props) {
        super(props);
        this.handleColorSelect = (colour) => {
            this.handleColorChange(colour);
            const { r, g, b } = colour.rgb;
            const { round } = Math;
            this.props.onChange(`rgba(${round(r)}, ${round(g)}, ${round(b)}, ${this.state.alpha})`);
        };
        this.handleAlphaSelect = (alpha) => {
            this.handleAlphaChange(alpha);
            const { r, g, b } = this.state.colour.rgb;
            const { round } = Math;
            this.props.onChange(`rgba(${round(r)}, ${round(g)}, ${round(b)}, ${alpha})`);
        };
        this.handleColorChange = (colour) => {
            const hex = colour.hex.replace('#', '');
            this.setState({ colour, hex: this.hexLength === 3 ? hex[0] + hex[2] + hex[4] : hex });
        };
        this.handleAlphaChange = (alpha) => {
            this.setState({ alpha });
        };
        this.handleAlphaInput = (alp) => {
            const alpha = parseInt(alp, 10) / 100;
            this.handleAlphaChange(alpha);
            this.handleAlphaSelect(alpha);
        };
        this.handleHexInput = (hex) => {
            this.setState({ hex });
            this.hexLength = hex.length;
            if (/^#([0-9A-F]{3}){1,2}$/i.test(`#${hex}`)) {
                const colour = convert(`#${hex.length === 3 ? hex.replace(/([0-9A-F])([0-9A-F])([0-9A-F])/i, '$1$1$2$2$3$3') : hex}`);
                this.handleColorChange(colour);
                this.handleColorSelect(colour);
            }
        };
        this.handleRgbInput = (red = this.state.colour.rgb.r, green = this.state.colour.rgb.g, blue = this.state.colour.rgb.b) => {
            const colour = convert({ r: red, g: green, b: blue });
            this.handleColorChange(colour);
            this.handleColorSelect(colour);
        };
        let alpha = 1;
        let colour = convert({ h: 240, s: 90, v: 30 });
        if (this.props.colour) {
            const hexA = rgbaToHexA(this.props.colour);
            colour = convert(hexA.hex);
            alpha = hexA.alpha;
        }
        this.state = {
            colour,
            alpha,
            hex: colour.hex.replace('#', ''),
        };
    }
    render() {
        const { colour, alpha, hex } = this.state;
        const { round } = Math;
        const previewBorderStyle = colour.hex === '#FFFFFF' ? { border: '1px solid rgb(0,0,0,0.08)' } : {};
        return React.createElement("div", { className: styles.panel, style: this.props.style },
            React.createElement(Palette, { color: colour, onColorSelect: this.handleColorSelect, onColorChange: this.handleColorChange }),
            React.createElement("div", { className: styles.controller },
                React.createElement("div", { className: styles.sliders },
                    React.createElement(Hue, { color: colour, onColorChange: this.handleColorChange, onColorSelect: this.handleColorSelect }),
                    React.createElement(Alpha, { color: colour, alpha: alpha, onAlphaChange: this.handleAlphaChange, onAlphaSelect: this.handleAlphaSelect })),
                React.createElement("div", { className: styles.preview },
                    React.createElement("div", { className: styles.color, style: Object.assign({ background: colour.hex, opacity: alpha }, previewBorderStyle) }))),
            React.createElement("div", { className: styles.percise },
                React.createElement(ColorInput, { flex: 2, value: hex, onChange: this.handleHexInput, label: "hex", style: { paddingRight: 3 } }),
                React.createElement(ColorInput, { flex: 1, value: `${round(colour.rgb.r)}`, onChange: (red) => { this.handleRgbInput(+red); }, label: "r", range: [0, 255], style: { paddingLeft: 3, paddingRight: 3 } }),
                React.createElement(ColorInput, { flex: 1, value: `${round(colour.rgb.g)}`, onChange: (green) => { this.handleRgbInput(undefined, +green); }, label: "g", range: [0, 255], style: { paddingLeft: 3, paddingRight: 3 } }),
                React.createElement(ColorInput, { flex: 1, value: `${round(colour.rgb.b)}`, onChange: (blue) => { this.handleRgbInput(undefined, undefined, +blue); }, label: "b", range: [0, 255], style: { paddingLeft: 3, paddingRight: 3 } }),
                React.createElement(ColorInput, { flex: 1, value: `${round(alpha * 100)}`, onChange: this.handleAlphaInput, label: "a", range: [0, 100], style: { paddingLeft: 3 } })));
    }
}

export { CustomSketch };
//# sourceMappingURL=custom-sketch.js.map
